import React, { useCallback, useState } from "react";

import { PlatformSubscriptionRow } from "../../common/platformTypes";
import { PagedListPage, PagedLoad } from "../../components/PagedListPage";
import { PlatformSubscriptionsTable } from "../../components/PlatformSubscriptionsTable";
import { listSubscriptions } from "../../services/api/Platform";

/** Subscription lookup by id, for the ids that arrive in support tickets. */
export const PlatformSubscriptionsPage: React.FunctionComponent = () => {
  const [activeOnly, setActiveOnly] = useState(false);

  const load = useCallback<PagedLoad<PlatformSubscriptionRow>>(
    (params) =>
      listSubscriptions({
        ...params,
        active: activeOnly ? true : undefined,
      }),
    [activeOnly],
  );

  return (
    <PagedListPage<PlatformSubscriptionRow>
      title="Platform Subscriptions"
      placeholder="Subscription ID or team name"
      componentName="subscription"
      load={load}
      filterKey={activeOnly ? "active" : ""}
      renderTable={(rows) => (
        <PlatformSubscriptionsTable subscriptions={rows} />
      )}
    >
      <div className="form-check pt-2">
        <input
          type="checkbox"
          className="form-check-input"
          id="subs-active-only"
          checked={activeOnly}
          onChange={(e) => setActiveOnly(e.target.checked)}
        />
        <label className="form-check-label" htmlFor="subs-active-only">
          Active only
        </label>
      </div>
    </PagedListPage>
  );
};
